<template>
  <span :class="className">
    <div
      class="tooltip__bubble"
      v-if="show"
      v-html="text" />
    <span
      class="tooltip__icon"
      @mouseover="show = true"
      @mouseout="show = false">
      <sprite
        id="app/information"
        class="tooltip__sprite" />
    </span>
  </span>
</template>

<script>
import Sprite from "@/shared/sprite";
import "/wds/sprites/app/information.svg";
import bemBlockModifiers from "utils/bem-block-modifiers";

export default {
  name: "InfoTooltip",
  components: { Sprite },
  props: {
    text: {
      type: String,
      required: true
    },
    modifiers: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({ show: false }),
  computed: {
    className() {
      return {
        [bemBlockModifiers("tooltip", this.modifiers)]: true
      };
    }
  }
};
</script>

<style lang="scss">
.tooltip {
  $root: &;

  position: relative;

  &__icon {
    cursor: default;
  }

  &__sprite {
    display: inline-block;
    width: $spacing-16;
    height: auto;
  }

  &__bubble {
    @include font-style(legal, $color: $white);

    position: absolute;
    right: $base;
    bottom: rem(30px); /* stylelint-disable-line unit-blacklist */

    min-width: rem(230px);
    max-width: $wide-block-width;
    padding: $basex2;

    white-space: normal;

    background-color: $blue-dark;

    border-radius: $border-radius-4 $border-radius-4 0 $border-radius-4;

    &:after {
      content: "";

      position: absolute;
      right: 0;
      bottom: rem(-10px); /* stylelint-disable-line unit-blacklist */

      width: 0;
      height: 0;

      border-width: 0 rem(10px) rem(10px) 0;
      border-style: solid;
      border-color: transparent $blue-dark transparent transparent;
    }
  }

  &--right {
    #{$root}__bubble {
      right: auto;
      left: $base;

      border-radius: rem(4px) rem(4px) rem(4px) 0;

      &:after {
        right: auto;
        left: 0;

        border-width: rem(10px) rem(10px) 0 0;
        border-color: $blue-dark transparent transparent transparent;
      }
    }
  }
}
</style>
